// props
import { IRaygunOptions } from 'src/app/props';
// functions
import { parseJwt } from 'src/utils/jwt';
import { getAuth } from 'src/app/functions/storage';

declare let rg4js: (method: string, option: IRaygunOptions) => void;

/**
 * Set up Raygun with the currently logged-in user.
 * Call with identifier from MSAL (getAccount()?.idTokenClaims?.tid ?? localAccountId)
 * or call with no args to use legacy getAuth().profile (fallback).
 */
export const registerUserInRaygun = (identifier?: string): void => {
  if (process.env.NODE_ENV !== 'production') {return;}
  const id = identifier ?? (() => {
    const authData = getAuth();
    if (authData?.profile) {
      try {
        const { tid } = parseJwt(authData.profile);
        return tid;
      } catch {
        return undefined;
      }
    }
    return undefined;
  })();
  if (id) {
    rg4js('setUser', { identifier: String(id), isAnonymous: false });
  }
};
